import React from 'react';
import { OutlinedInput } from '@mui/material';
import { FieldInfoIcon } from 'src/components/FieldInfoIcon';

export function buildSelectInputWithInfo({
  label,
  title,
}: {
  label: string;
  title: React.ReactNode;
}) {
  return (
    <OutlinedInput
      label={label}
      endAdornment={<FieldInfoIcon title={title} />}
    />
  );
}
